export default "__VITE_ASSET__DsJoFlYt__"